module.exports = __webpack_public_path__ + "img/fuweining.fa1d3b59.jpg";